import { render, staticRenderFns } from "./ModalSeleccionarPersona.vue?vue&type=template&id=77d275cc&"
import script from "./ModalSeleccionarPersona.vue?vue&type=script&lang=js&"
export * from "./ModalSeleccionarPersona.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports